module.exports = __webpack_public_path__ + "pin_lightturquoise.228dde.png";